import ReducerRegistry from '../base/redux/ReducerRegistry';

import {
  RESET_WHITEBOARD,
  SETUP_WHITEBOARD,
  TOGGLE_WHITEBOARD
} from './actionTypes';

// export interface IWhiteboardState {

//     /**
//      * The whiteboard collaboration details.
//      */
//     collabDetails?: { roomId: string; roomKey: string; };

//     /**
//      * The indicator which determines whether the whiteboard is open.
//      *
//      * @type {boolean}
//      */
//     isOpen: boolean;
// }

const DEFAULT_STATE = {
  isOpen: false
};

// export interface IWhiteboardAction extends Partial<IWhiteboardState> {

//     /**
//      * The whiteboard collaboration details.
//      */
//     collabDetails?: { roomId: string; roomKey: string; };
//     isOpen?: boolean;
//     /**
//      * The action type.
//      */
//     type: string;
// }

ReducerRegistry.register(
  'features/whiteboard',
  (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      case SETUP_WHITEBOARD: {
        return {
          ...state,
          ...action.data
        };
      }
      case TOGGLE_WHITEBOARD:
        return {
          ...state,
          isOpen: action.isOpen
        };
      case RESET_WHITEBOARD:
        return DEFAULT_STATE;
    }
    return state;
  }
);
